import { useEffect, useState } from 'react';
import ProgressBar from './progress-bar';
import 'twin.macro';

const UserSection = ({
  playVideo,
  feedBackprogress,
  feedBackUserVideoRef,
  feedbackResultTurn,
  setFeedBackProgress,
  setIsPlayingFeedback,
  isPlayingFeed,
  videoRecordSrc,
  imageUrl,
}) => {
  const [showImage, setShowImage] = useState(true);

  useEffect(() => {
    if (playVideo?.feed_back_video && feedbackResultTurn === 2) {
      setTimeout(() => {
        setShowImage(false);
        feedBackUserVideoRef.current.play();
      }, 100);
    }
  }, [playVideo?.feed_back_video, feedbackResultTurn]);

  useEffect(() => {
    let intervalId;
    if (playVideo?.feed_back_video && feedbackResultTurn === 2) {
      const step = 5;
      const numberOfSteps = 100 / step;
      const durationTime =
        (playVideo.feed_back_video.to - playVideo.feed_back_video.from) *
        (1 / playVideo.feed_back_video.speed) *
        1000;
      const intervalTime = durationTime / numberOfSteps;

      intervalId = setInterval(() => {
        setFeedBackProgress(prev => Math.min(prev + step, 100));
      }, intervalTime);
    } else if (feedbackResultTurn < 2) {
      setFeedBackProgress(1);
    }
    return () => clearInterval(intervalId);
  }, [feedBackUserVideoRef?.current?.paused, playVideo?.feed_back_video]);

  useEffect(() => {
    if (feedBackUserVideoRef.current && playVideo?.feed_back_video?.from) {
      // for set current video time on time that come from backed and set speed also
      feedBackUserVideoRef.current.currentTime = playVideo?.feed_back_video?.from;
      feedBackUserVideoRef.current.playbackRate = playVideo?.feed_back_video?.speed;
    }
  }, [playVideo?.feed_back_video?.from]);

  useEffect(() => {
    if (!feedBackUserVideoRef?.current?.paused && feedBackprogress >= 100) {
      // stop video when feedback user video is finish and isSteal playing
      feedBackUserVideoRef?.current?.pause();
      setIsPlayingFeedback(false);
    }
  }, [feedBackUserVideoRef, feedBackprogress]);

  return (
    <div tw="relative h-[inherit]">
      <video
        preload="metadata"
        // Without playsinline iOS Safari opens its own fullscreen player on play.
        playsInline
        webkit-playsinline="true"
        disablePictureInPicture
        id="video-ref"
        tw="w-full h-[99%] object-fill scale-x-[-1] rounded-bl-[20px] rounded-tl-[20px]"
        src={videoRecordSrc}
        style={{
          filter: !isPlayingFeed ? 'grayscale(1)' : 'grayscale(0)',
        }}
        muted
        ref={feedBackUserVideoRef}
      />
      {showImage && (
        <img loading="lazy" decoding="async"
          src={imageUrl}
          alt="start frame"
          style={{ filter: 'grayscale(1)' }}
          tw="w-full absolute top-0 left-0 h-[99%] bg-red-500 object-fill scale-x-[-1] rounded-bl-[20px] rounded-tl-[20px]"
        />
      )}
      <ProgressBar backGroundBar="#D12E3C" level={feedBackprogress} />
    </div>
  );
};

export default UserSection;
